import { render, staticRenderFns } from "./cloundorderdetail.vue?vue&type=template&id=946a5582&scoped=true"
import script from "./cloundorderdetail.vue?vue&type=script&lang=js"
export * from "./cloundorderdetail.vue?vue&type=script&lang=js"
import style0 from "./cloundorderdetail.vue?vue&type=style&index=0&id=946a5582&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "946a5582",
  null
  
)

export default component.exports